import { FormEvent, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { SlideOutModal, SlideOutModalProps, TextWithValidation } from "../../../../components";
import { BlogAuthorModel } from "../../../../data/entities";

export interface AddAuthorModalProps extends SlideOutModalProps {
  onSubmit: (data: any) => void;
}

export function AddAuthorModal(props: Readonly<AddAuthorModalProps>) {
  const [validated, setValidated] = useState(false);
  const [values, setValues] = useState({
    displayName: "",
    firstName: "",
    imageUrl: "",
    lastName: "",
    signature: "",
  } as BlogAuthorModel);

  const formRef = useRef<HTMLFormElement>(null);
  const formSubmitRef = useRef<HTMLButtonElement>(null);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity()) {
      setValidated(true);
      props.onSubmit.call(null, values);
      resetForm();
    } else {
      setValidated(false);
    }
  };

  const resetForm = () => {
    setValues({
      friendlyTitle: "",
      signature: "",
    } as BlogAuthorModel);
    setValidated(false);
  }

  return (
    <SlideOutModal {...props}
      title={`Add New Author`}
      footer={<div className="container p-0">
        <div className="row g-0">
          <div className="col-6 pe-2">
            <Button onClick={() => props.showState.setter(false)} variant="cancel" className="w-100">
              Cancel
            </Button>
          </div>
          <div className="col-6 ps-2">
            <Button onClick={() => formSubmitRef.current?.click()} variant="primary" className="w-100">
              Add
            </Button>
          </div>
        </div>
      </div>}>
      <Form ref={formRef} noValidate validated={validated} onSubmit={handleSubmit}>
        <div className="col-12">
          <TextWithValidation
            id="avatarUrl"
            required={true}
            label="Avatar Image URL"
            initialValue={values.imageUrl}
            onChangeText={(v) => setValues({ ...values, imageUrl: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="firstName"
            required={true}
            label="First Name"
            initialValue={values.firstName}
            onChangeText={(v) => setValues({ ...values, firstName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="lastName"
            required={true}
            label="Last Name"
            initialValue={values.lastName}
            onChangeText={(v) => setValues({ ...values, lastName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="displayName"
            required={true}
            label="Display Name"
            initialValue={values.displayName}
            onChangeText={(v) => setValues({ ...values, displayName: v })}
          /> 
        </div>
        <div className="col-12">
          <TextWithValidation
            id="signature"
            required={true}
            label="Signature"
            initialValue={values.signature}
            onChangeText={(v) => setValues({ ...values, signature: v })}
          />
        </div>
        <Button ref={formSubmitRef} type="submit" className="d-none" />
      </Form>
      {props.children}
    </SlideOutModal>
  );
}

export default AddAuthorModal;

